import Badge from "../../../components/ui/Badge";
import { formatDate } from "../../../utils/date";
import { getFullName, getInitials, getStatusTone } from "../profileUtils";
import styles from "../Profile.module.css";

const ProfileHeader = ({ profile, photoUrl }) => {
  const fullName = getFullName(profile);

  const meta = [
    { label: "Department", value: profile.department?.departmentName },
    { label: "Branch", value: profile.branch?.branchName },
    { label: "Company", value: profile.company?.companyName },
    {
      label: "Hired",
      value: profile.hiringDate && formatDate(profile.hiringDate),
    },
  ];

  return (
    <div className={styles.header}>
      {photoUrl ? (
        <img src={photoUrl} alt={fullName} className={styles.avatar} />
      ) : (
        <div className={styles.avatarPlaceholder} aria-hidden="true">
          {getInitials(profile)}
        </div>
      )}

      <div className={styles.identity}>
        <h2 className={styles.name}>{fullName}</h2>
        <div className={styles.employeeNo}>{profile.employeeId}</div>
        <div className={styles.identityBadges}>
          {profile.role?.title && (
            <Badge tone="blue">{profile.role.title}</Badge>
          )}
          {profile.employeeStatus && (
            <Badge tone={getStatusTone(profile.employeeStatus)}>
              {profile.employeeStatus}
            </Badge>
          )}
        </div>
      </div>

      <div className={styles.headerMeta}>
        {meta.map((item) => (
          <div key={item.label}>
            <div className={styles.headerMetaLabel}>{item.label}</div>
            <div className={styles.headerMetaValue}>{item.value || "—"}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileHeader;
